import { useContext } from 'react';
import AppContext from '../../../common/containers/AppContext';

/**
 * Checks if a user can access a feature in the application with at least one of the features given.
 *
 * @example Users can access AdminConsole if they have UpdateCustomer *or* UpdateClient (i.e., both are not needed)
 *
 * @param {import('./Permissions').Permission[]} permissionsAllowed
 * @returns {boolean} true if any of the permissions are found for the user
 */
export default function useUserCanAccess(permissionsAllowed) {
    const { permissionsToFamilies = {} } = useContext(AppContext);
    return permissionsAllowed.some((permission) => permission in permissionsToFamilies);
}
